(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["MM-Section-Denim-Ancre"] && !Shopify.designMode) return;
  try {
    
    document.addEventListener('click', function (event) {
        var link = event.target.closest('.mm-wrapper-denim-ancre a[href^="#"]');
        if (!link) return;

        var targetId = link.getAttribute('href').slice(1);
        var target = targetId ? document.getElementById(targetId) : null;
        if (!target) return;

        event.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });

    // Indice de swipe cliquable : avance le splide d'un slide
    document.addEventListener('click', function (event) {
        var hint = event.target.closest('.mm-wrapper-denim-ancre .mm-swipe-hint-next');
        if (!hint) return;

        var splideEl = hint.closest('.splide');
        if (splideEl && splideEl._splide) {
            splideEl._splide.go('+1');
        }
    });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["MM-Section-Denim-Produit"] && !Shopify.designMode) return;
  try {
    
    // Indice de swipe cliquable : avance le splide d'un slide
    document.addEventListener('click', function (event) {
        var hint = event.target.closest('.mm-wrapper-denim-produit .mm-swipe-hint-next');
        if (!hint) return;

        var splideEl = hint.closest('.splide');
        if (splideEl && splideEl._splide) {
            splideEl._splide.go('+1');
        }
    });

  } catch(e) { console.error(e); }
})();
})();
